import React from 'react';
import styles from './Drawer.module.css';
import { NavLink } from 'react-router-dom';
import Backdrop from '../../UI/Backdrop';
import nextId from "react-id-generator";
import { bool, func } from 'prop-types';

const Drawer = ({ isOpen, isAuthenticated, onClose }) => {
  const cls = [styles.drawer]

  if (!isOpen) {
    cls.push(styles.close)
  }

  const links = [
    { to: '/', label: 'Список', exact: true },
  ]

  if (isAuthenticated) {
    links.push({ to: '/quiz-creator', label: 'Создать тест', exact: false })
    links.push({ to: '/logout', label: 'Выйти', exact: false })
  } else {
    links.push({ to: '/auth', label: 'Авторизация', exact: false })
  }

  return (
    <>
      <nav className={cls.join(' ')}>
        <ul>
          {
            links.map(({ to, exact, label }) => {
              return (
                <li key={nextId()}>
                  <NavLink
                    to={to}
                    exact={exact}
                    activeClassName={styles.active}
                    onClick={() => onClose()}
                  >
                    {label}
                  </NavLink>
                </li>
              )
            })
          }
        </ul>
      </nav>

      {isOpen && <Backdrop onClick={onClose} />}
    </>
  )
}

Drawer.propTypes = {
  isOpen: bool,
  isAuthenticated: bool,
  onClose: func,
}

Drawer.defaultProps = {
  isOpen: false,
  isAuthenticated: false,
  onClose: () => { },
}

export default Drawer